/**
 * All Permissions for Contract Operator role
 */
export const CONTRACT_OPERATOR_PERMISSIONS: string[] = [
  'dashboardView',

  // 'terminalCreate',
  'terminalView',
  'terminalDetail',
  'terminalNotes',
  // 'terminalEdit',
  // 'terminalConfigure',
  // 'terminalRemove',
  // 'terminalAssign',

  // 'terminalBulkTemplateApply',

  // 'terminalActionRestart',
  // 'terminalActionPushConfig',
  // 'terminalActionPullConfig',
  // 'terminalActionResetConfig',
  // 'terminalActionUpgradeConfig',
  // 'terminalActionTerminalType',
  // 'terminalAdvancedEdit',
  // 'terminalTransactions',

  'registrationCreate',
  'registrationView',
  'registrationEdit',
  'registrationFinalize',
  'registrationCancel',
  'registrationTRF',
  'registrationDeactivate',
  'registrationRemove',

  // 'transactionView',

  // 'eventView',
  // 'deliveryCreate',

  // 'assetView',
  // 'administrationView',

  // 'domainView',
  // 'domainCreate',
  // 'domainEdit',
  // 'domainRemove',
  // 'domainContractTypeView',
  // 'domainContractTypeEdit',
  // 'domainTerminalTypeView',
  // 'domainTerminalTypeEdit',
  // 'domainDataView',
  // 'domainDataEdit',
  // 'domainAssetView',
  // 'domainAssetEdit',

  // 'roleView',
  // 'roleCreate',
  // 'roleCreateInheritable',
  // 'roleEdit',
  // 'roleRemove',

  // 'userView',
  // 'userCreate',
  // 'userEdit',
  // 'userRemove',
  // 'userPasswordRequest',

  // 'templateView',
  // 'templateCreate',
  // 'templateEdit',
  // 'templateRemove',
  // 'templateConfigurationEdit',

  // 'contractCreate',
  // 'contractView',
  // 'contractEdit',
  // 'contractRemove',

  // 'taskView',
  // 'taskCreate',

  // 'terminalImport',
  // 'editNotes',
]
